export default __webpack_public_path__ + "static/media/pdf.f8d8e5a2.svg";